import { render } from "./3二级指标部门不合格分布.vue?vue&type=template&id=3c3825e4&scoped=true"
import script from "./3二级指标部门不合格分布.vue?vue&type=script&lang=js"
export * from "./3二级指标部门不合格分布.vue?vue&type=script&lang=js"

import "./3二级指标部门不合格分布.vue?vue&type=style&index=0&id=3c3825e4&scoped=scoped&lang=css"
script.render = render
script.__scopeId = "data-v-3c3825e4"

export default script